// @flow
import { handleActions } from 'redux-actions';
import { List as ImmutableList, Record } from 'immutable';
import type { RecordFactory } from 'immutable';

import { getLogger } from 'utils/logger';

import * as undoActions from './undoActions';

const log = getLogger('data/undo/undoReducer.js');
export const UNDO_REDUCER_KEY = 'undoStore';

type UndoStoreProps = {
  undoStack: Object,
};
export const mkUndoStore: RecordFactory<UndoStoreProps> =
  Record({
    undoStack: new ImmutableList(),
  });

const maxUndoStackSize = 1;

export const reducer = handleActions({
  [undoActions.addUndo]: (state, { payload: undo }) => {
    log.log('addUndoAction...');
    return state.merge({
      undoStack: state.undoStack
        .takeLast(maxUndoStackSize - 1)
        .push(undo),
    });
  },

  [undoActions.undo]: (state, { payload: undoToDispatch, asyncDispatch }) => {
    log.log('dispatchPostponedActions...');
    undoToDispatch.actions.forEach((action) => asyncDispatch(action));
    return state.merge({
      undoStack: state.undoStack.filterNot((undo) => undo === undoToDispatch),
    });
  },

  [undoActions.deleteUndo]: (state, { payload: undoToDismiss }) => {
    log.log('deleteUndoAction...');
    return state.merge({
      undoStack: state.undoStack.filterNot((undo) => undo === undoToDismiss),
    });
  },

  [undoActions.clearUndoStack]: (state) => {
    log.log('deleteUndoAction...');
    return state.merge({
      undoStack: new ImmutableList(),
    });
  },
}, mkUndoStore());

export default reducer;
